// components/common/StandardHeader.jsx - ABSOLUTE MINIMAL (No Overflow Issues)
import React from 'react';
import { 
  ArrowPathIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import DateRangeSelector from './DateRangeSelector';
import Button from './Button';

import { formatLastUpdated } from '../../utils';

export const StandardHeader = ({ 
  title,
  subtitle,
  loading, 
  lastUpdated, 
  dateRange, 
  onDateRangeChange,
  onRefresh,
  refreshButtonText = 'Refresh',
  isRefreshing = false,
  yearsOnly = false,
  customControls = null,
  additionalTimestamps = null,
}) => {
  const isLoading = loading || isRefreshing;

  return (
    <div className="bg-brightblue-500 rounded-xl shadow-sm border border-gray-200 p-3 sm:p-4 md:p-6">
      {/* Main container - NO size constraints that could cause issues */}
      
      <div className="flex flex-col space-y-2 sm:space-y-3 lg:space-y-0 lg:flex-row lg:items-center lg:justify-between">
        {/* NO overflow-hidden, NO max-w-full, NO min-w-0 on main container */}
        
        {/* Title Section */}
        <div className="flex-1">
          {/* CAN have constraints here - no dropdowns in title area */}
          
          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-3 space-y-2 sm:space-y-0">
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-white">
              {/* Removed truncate - let title wrap if needed */}
              {title}
            </h1>
          </div>
          
          {subtitle && (
            <div className="text-white mt-1 sm:mt-2 text-xs sm:text-sm md:text-base text-left overflow-hidden">
              {subtitle}
            </div>
          )}
        </div>
        
        {/* Controls Section - COMPLETELY UNCONSTRAINED */}
        <div className="flex flex-col items-stretch sm:items-end space-y-2 sm:space-y-0">
          {/* NO flex-shrink-0, NO overflow constraints */}
          
          <div className="flex flex-row items-center gap-2 sm:gap-3 md:gap-4">
            {/* NO flex-wrap, NO min-w-0 - let it breathe */}
            
            {/* Date Range Selector - ZERO constraints */}
            {dateRange && onDateRangeChange && (
              <DateRangeSelector
                dateRange={dateRange}
                onDateRangeChange={onDateRangeChange}
                className="w-full sm:w-auto"
                yearsOnly={yearsOnly}
              />
            )}
            
            {/* Custom Controls - ZERO constraints */}
            {customControls}
            
            {/* Refresh Button */}
            {onRefresh && (
              <>
              {/* Mobile: Icon only */}
                <Button
                  variant="primary"
                  size="md"
                  iconOnly
                  leftIcon={<ArrowPathIcon className={isLoading ? 'animate-spin' : ''} />}
                  onClick={onRefresh}
                  disabled={isLoading}
                  className="sm:hidden"
                  title="Refresh data from source"
                />
                
                {/* Desktop: Full button with text */}
                <Button
                  variant="primary"
                  size="md"
                  leftIcon={<ArrowPathIcon className={isLoading ? 'animate-spin' : ''} />}
                  onClick={onRefresh}
                  loading={isLoading}
                  disabled={isLoading}
                  className="hidden sm:inline-flex"
                >
                  {isLoading ? 'Refreshing...' : refreshButtonText}
                </Button>
                
                </>
              // <button
              //   onClick={onRefresh}
              //   disabled={isLoading}
              //   className={`inline-flex items-center justify-center px-2 sm:px-4 py-2 rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              //     isLoading
              //       ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              //       : 'bg-blue-600 text-white hover:bg-blue-700'
              //   }`}
              //   title="Refresh data from source"
              // >
              //   <ArrowPathIcon className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
              //   <span className="ml-2 hidden sm:inline">
              //     {isLoading ? 'Refreshing...' : refreshButtonText}
              //   </span>
              // </button>
            )}
          </div>
        </div>
      </div>

      {/* Timestamps row */}
      {(lastUpdated || additionalTimestamps) && (
        <div className="mt-2 sm:mt-3 text-xs sm:text-sm text-blue-100 flex flex-col items-start sm:items-end space-y-1">
          
          {lastUpdated && (
            <div className="flex items-center space-x-1">
              <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4" />
              <span>Last updated: {formatLastUpdated(lastUpdated)}</span>
            </div>
          )}

          {additionalTimestamps && (
            <div className="w-full sm:w-auto text-left sm:text-right">
              {additionalTimestamps}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
